import { render, staticRenderFns } from "./Plates.vue?vue&type=template&id=7fc05ffc&scoped=true"
import script from "./Plates.vue?vue&type=script&lang=js"
export * from "./Plates.vue?vue&type=script&lang=js"
import style0 from "./Plates.vue?vue&type=style&index=0&id=7fc05ffc&prod&scoped=true&lang=css"
import style1 from "./Plates.vue?vue&type=style&index=1&id=7fc05ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc05ffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSelect,VTextField})
